module.exports = __webpack_public_path__ + "static/media/Lockup_Edge_2024.72d02eb0.svg";